import React from 'react';
import { PhoneIcon, MapPinIcon, MailIcon } from 'lucide-react';
export function ClubInfoCards() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-791">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-792">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-793">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-794">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-795">
              <PhoneIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-796" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-797">
              Phone
            </h3>
            <a href="tel:8106297964" className="text-base font-semibold hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-798">
              (810) 629-7964
            </a>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-799">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-800">
              <MapPinIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-801" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-802">
              Address
            </h3>
            <p className="text-base text-gray-700" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-803">
              1140 Butcher Rd
              <br data-id="element-804" />
              Fenton, MI 48430-1232
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-805">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-806">
              <MailIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-807" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-808">
              Email
            </h3>
            <a href="mailto:Clubpresident@fentonlakes.com" className="text-base font-semibold hover:underline" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-809">
              Clubpresident@fentonlakes.com
            </a>
          </div>
        </div>
      </div>
    </div>;
}